import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const SegmentCreateEditRBAC = {
  pageID: '7aeb999b902cb7d8ba447c9f6853ad90',
  elementID: {
    View: 'a04a402a35d8e8ec35b5bac3cbf5a3d6',
    Create: '3b0ad3ad7b33144342a3e23255af2f6f',
    Edit: '2911faab0b1425bbf709c7c520c7a74f',
  },
} as const

export const useRBACSegmentCreateEditPage = createUseRBAC(SegmentCreateEditRBAC.elementID)

export type UseRBACSegmentCreateEditPageType = ReturnType<typeof useRBACSegmentCreateEditPage>
